import invariant from 'invariant';

var keys = Object.keys,
    getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors,
    defineProperty = Object.defineProperty;
invariant(getOwnPropertyDescriptors, "funcadelic.js requires Object.getOwnPropertyDescriptors. See https://github.com/cowboyd/funcadelic.js#compatibility");
invariant("name" in Function.prototype && "name" in function x() {}, "funcadelic.js requires Function.name. See https://github.com/cowboyd/funcadelic.js#compatibility");
var VERSION = 0;
var uniqueTag = 0;
function type(Class) {
  var name = Class.name;

  if (!name) {
    throw new Error('invalid typeclass name: ' + name);
  }

  var symbolName = "@@funcadelic-".concat(VERSION, "/").concat(name, "/").concat(uniqueTag++);
  var symbol = Symbol[symbolName] ? Symbol[symbolName] : Symbol[symbolName] = Symbol(symbolName);

  Class.for = function _for(value) {
    var i = value[symbol];

    if (!i) {
      throw new Error("No instance found on ".concat(value, " of typeclass ").concat(name));
    }

    return i;
  };

  Class.instance = function (constructor, methods) {
    defineProperty(constructor.prototype, symbol, {
      value: methods,
      configurable: true,
      enumerable: false
    });
  };

  Class.symbolName = symbolName;
  Class.symbol = symbol;
  var properties = getOwnPropertyDescriptors(Class.prototype);
  keys(properties).filter(function (key) {
    return key != 'constructor';
  }).forEach(function (key) {
    Class.prototype[key] = Class.prototype[key].bind(Class.for);
  });
  return Class;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineEnumerableProperties(obj, descs) {
  for (var key in descs) {
    var desc = descs[key];
    desc.configurable = desc.enumerable = true;
    if ("value" in desc) desc.writable = true;
    Object.defineProperty(obj, key, desc);
  }

  if (Object.getOwnPropertySymbols) {
    var objectSymbols = Object.getOwnPropertySymbols(descs);

    for (var i = 0; i < objectSymbols.length; i++) {
      var sym = objectSymbols[i];
      var desc = descs[sym];
      desc.configurable = desc.enumerable = true;
      if ("value" in desc) desc.writable = true;
      Object.defineProperty(obj, sym, desc);
    }
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var Semigroup = type(function () {
  function Semigroup() {
    _classCallCheck(this, Semigroup);
  }

  _createClass(Semigroup, [{
    key: "append",
    value: function append(left, right) {
      var _this = this(left),
          append = _this.append;

      return append(left, right);
    }
  }]);

  return Semigroup;
}());
var append = Semigroup.prototype.append;

var Foldable = type(function () {
  function Foldable() {
    _classCallCheck(this, Foldable);
  }

  _createClass(Foldable, [{
    key: "foldr",
    value: function foldr(fn, initial, foldable) {
      var _this = this(foldable),
          foldr = _this.foldr;

      return foldr(fn, initial, foldable);
    }
  }, {
    key: "foldl",
    value: function foldl(fn, initial, foldable) {
      var _this2 = this(foldable),
          foldl = _this2.foldl;

      return foldl(fn, initial, foldable);
    }
  }, {
    key: "size",
    value: function size(foldable) {
      var _this3 = this(foldable),
          foldr = _this3.foldr;

      return foldr(function (len) {
        return len + 1;
      }, 0, foldable);
    }
  }]);

  return Foldable;
}());
var _Foldable$prototype = Foldable.prototype,
    foldr = _Foldable$prototype.foldr,
    foldl = _Foldable$prototype.foldl,
    size = _Foldable$prototype.size;

var Stable = Symbol('Stable');
function stable(fn) {
  switch (fn.length) {
    case 0:
      return thunk(fn);

    case 1:
      return stableOne(fn);

    default:
      throw new Error("Cannot (yet) make functions with ".concat(fn.length, " stable"));
  }
}
function thunk(fn) {
  if (fn[Stable]) {
    return fn;
  }

  var evaluated = false;
  var result = undefined;

  function evaluate() {
    if (evaluated) {
      return result;
    } else {
      result = fn.call(this);
      evaluated = true;
      return result;
    }
  }

  evaluate[Stable] = true;
  return evaluate;
}
function stableOne(fn) {
  if (fn[Stable]) {
    return fn;
  }

  var cache = new WeakMap();

  function stabilizedOne(argument) {
    if (!cache.has(argument)) {
      cache.set(argument, fn(argument));
    }

    return cache.get(argument);
  }

  stabilizedOne[Stable] = true;
  return stabilizedOne;
}

var getPrototypeOf = Object.getPrototypeOf,
    getOwnPropertyDescriptors$1 = Object.getOwnPropertyDescriptors,
    getOwnPropertySymbols = Object.getOwnPropertySymbols;
Semigroup.instance(Object, {
  append: function append$$1(o1, o2) {
    var properties = assign({}, getOwnPropertyDescriptors$1(o1), getOwnPropertyDescriptors$1(o2));
    return Object.create(getPrototypeOf(o1), stableize(properties));
  }
});

function assign(target, a, b) {
  function copy(source) {
    var keys = allKeys(source);
    var totalKeys = keys.length;

    for (var j = 0; j < totalKeys; j++) {
      var key = keys[j];
      target[key] = source[key];
    }
  }

  copy(a);
  copy(b);
  return target;
}

function stableize(properties) {
  return foldl(function (descriptors, key) {
    var descriptor = properties[key];

    if (!descriptor.get) {
      descriptors[key] = descriptor;
    } else {
      var getter = descriptor.get;
      var cached = stable(function (instance) {
        return getter.call(instance);
      });

      descriptor.get = function () {
        return cached(this);
      };

      descriptors[key] = descriptor;
    }

    return descriptors;
  }, {}, allKeys(properties));
}

function allKeys(o) {
  return Object.keys(o).concat(getOwnPropertySymbols(o));
}

Semigroup.instance(Array, {
  append: function append$$1(a1, a2) {
    return a1.concat(a2);
  }
});

var Functor = type(function () {
  function Functor() {
    _classCallCheck(this, Functor);
  }

  _createClass(Functor, [{
    key: "map",
    value: function map(fn, f) {
      var _this = this(f),
          map = _this.map;

      return map(fn, f);
    }
  }]);

  return Functor;
}());
var map = Functor.prototype.map;

var Monoid = type(function (_Semigroup) {
  _inherits(Monoid, _Semigroup);

  function Monoid() {
    _classCallCheck(this, Monoid);

    return _possibleConstructorReturn(this, _getPrototypeOf(Monoid).apply(this, arguments));
  }

  _createClass(Monoid, [{
    key: "reduce",
    value: function reduce(M, values) {
      var empty = this(M.prototype).empty();
      return foldl(function (reduction, value) {
        return append(reduction, value);
      }, empty, values);
    }
  }]);

  return Monoid;
}(Semigroup));

Monoid.create = function create(Definition) {
  var Monoidal = function (_Definition) {
    _inherits(Monoidal, _Definition);

    function Monoidal() {
      var _this;

      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Monoidal.prototype.empty();

      _classCallCheck(this, Monoidal);

      _this = _possibleConstructorReturn(this, _getPrototypeOf(Monoidal).call(this));
      _this.value = value;
      return _this;
    }

    return Monoidal;
  }(Definition);

  Monoidal.reduce = function (list) {
    return reduce(Monoidal, map(function (i) {
      return new Monoidal(i);
    }, list)).value;
  };

  Semigroup.instance(Monoidal, {
    append: function append$$1(a, b) {
      return new Monoidal(Monoidal.prototype.append(a.value, b.value));
    }
  });
  Monoid.instance(Monoidal, {
    empty: function empty() {
      return new Monoidal();
    }
  });
  return Monoidal;
};

var reduce = Monoid.prototype.reduce;

Monoid.instance(Object, {
  empty: function empty() {
    return {};
  }
});

Monoid.instance(Array, {
  empty: function empty() {
    return [];
  }
});

var getPrototypeOf$1 = Object.getPrototypeOf,
    keys$1 = Object.keys;
Functor.instance(Object, {
  map: function map$$1(fn, object) {
    var descriptors = keys$1(object).reduce(function (descriptors, key) {
      descriptors[key] = {
        configurable: true,
        enumerable: true,
        get: stable(function () {
          return fn(object[key], key);
        })
      };
      return descriptors;
    }, {});
    return Object.create(getPrototypeOf$1(object), descriptors);
  }
});

Functor.instance(Array, {
  map: function map$$1(fn, array) {
    return array.map(fn);
  }
});

Functor.instance(Promise, {
  map: function map$$1(fn, promise) {
    return promise.then(fn);
  }
});

function curry(f) {
  return function curried() {
    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    if (t.length === 0) return curried;
    if (t.length >= f.length) return f.apply(void 0, t);
    return curried.bind.apply(curried, [this].concat(t));
  };
}
var Applicative = type(function (_Functor) {
  _inherits(Applicative, _Functor);

  function Applicative() {
    _classCallCheck(this, Applicative);

    return _possibleConstructorReturn(this, _getPrototypeOf(Applicative).apply(this, arguments));
  }

  _createClass(Applicative, [{
    key: "pure",
    value: function pure(Type, value) {
      return this(Type.prototype).pure(value);
    }
  }, {
    key: "apply",
    value: function apply(Type, fn, list) {
      var _this = this(Type.prototype),
          pure = _this.pure,
          applyOne = _this.applyOne;

      var initial = pure(curry(fn));
      return foldl(function (left, right) {
        return applyOne(left, right);
      }, initial, list);
    }
  }, {
    key: "applyOne",
    value: function applyOne(left, right) {
      this(left).applyOne(right);
    }
  }]);

  return Applicative;
}(Functor));
var _Applicative$prototyp = Applicative.prototype,
    pure = _Applicative$prototyp.pure,
    apply = _Applicative$prototyp.apply,
    applyOne = _Applicative$prototyp.applyOne;

Applicative.instance(Promise, {
  pure: function pure$$1(value) {
    return Promise.resolve(value);
  },
  applyOne: function applyOne$$1(left, right) {
    return Promise.all([left, right]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          fn = _ref2[0],
          value = _ref2[1];

      return fn(value);
    });
  }
});

var Monad = type(function (_Applicative) {
  _inherits(Monad, _Applicative);

  function Monad() {
    _classCallCheck(this, Monad);

    return _possibleConstructorReturn(this, _getPrototypeOf(Monad).apply(this, arguments));
  }

  _createClass(Monad, [{
    key: "flatMap",
    value: function flatMap(fn, m) {
      return this(m).flatMap(fn, m);
    }
  }]);

  return Monad;
}(Applicative));
var flatMap = Monad.prototype.flatMap;

Monad.instance(Array, {
  flatMap: function flatMap$$1(fn, array) {
    return reduce(Array, map(fn, array));
  }
});

Monad.instance(Promise, {
  flatMap: function flatMap$$1(fn, promise) {
    return promise.then(fn);
  }
});

Foldable.instance(Array, {
  foldr: function foldr$$1(fn, initial, array) {
    return array.reduceRight(fn, initial);
  },
  foldl: function foldl$$1(fn, initial, array) {
    return array.reduce(fn, initial);
  }
});

var keys$2 = Object.keys;
Foldable.instance(Object, {
  foldr: function foldr$$1(fn, initial, object) {
    return keys$2(object).reduceRight(function (memo, key) {
      return fn(memo, {
        key: key,

        get value() {
          return object[key];
        }

      });
    }, initial);
  },
  foldl: function foldl$$1(fn, initial, object) {
    return keys$2(object).reduce(function (memo, key) {
      return fn(memo, {
        key: key,

        get value() {
          return object[key];
        }

      });
    }, initial);
  }
});

var Filterable = type(function () {
  function Filterable() {
    _classCallCheck(this, Filterable);
  }

  _createClass(Filterable, [{
    key: "filter",
    value: function filter(fn, f) {
      return this(f).filter(fn, f);
    }
  }]);

  return Filterable;
}());
var filter = Filterable.prototype.filter;

var create = Object.create,
    getPrototypeOf$2 = Object.getPrototypeOf;
Filterable.instance(Object, {
  filter: function filter$$1(fn, object) {
    var instance = create(getPrototypeOf$2(object));
    return foldr(function (filtered, entry) {
      if (fn(entry)) {
        var _entry$key, _append, _mutatorMap;

        return append(filtered, (_append = {}, _entry$key = entry.key, _mutatorMap = {}, _mutatorMap[_entry$key] = _mutatorMap[_entry$key] || {}, _mutatorMap[_entry$key].get = function () {
          return entry.value;
        }, _defineEnumerableProperties(_append, _mutatorMap), _append));
      } else {
        return filtered;
      }
    }, instance, object);
  }
});

Filterable.instance(Array, {
  filter: function filter$$1(fn, array) {
    return array.filter(fn);
  }
});

var Chain = function () {
  function Chain() {
    _classCallCheck(this, Chain);
  }

  _createClass(Chain, [{
    key: "map",
    value: function map$$1(fn) {
      var _this = this;

      return new Thunk(function () {
        return map(fn, _this.valueOf());
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap$$1(fn) {
      var _this2 = this;

      return new Thunk(function () {
        return flatMap(fn, _this2.valueOf());
      });
    }
  }, {
    key: "filter",
    value: function filter$$1(fn) {
      var _this3 = this;

      return new Thunk(function () {
        return filter(fn, _this3.valueOf());
      });
    }
  }, {
    key: "append",
    value: function append$$1(thing) {
      var _this4 = this;

      return new Thunk(function () {
        return append(_this4.valueOf(), thing);
      });
    }
  }, {
    key: "tap",
    value: function tap(fn) {
      fn(this.valueOf());
      return this;
    }
  }]);

  return Chain;
}();

var Value = function (_Chain) {
  _inherits(Value, _Chain);

  function Value(value) {
    var _this5;

    _classCallCheck(this, Value);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Value).call(this));
    _this5.value = value;
    return _this5;
  }

  _createClass(Value, [{
    key: "valueOf",
    value: function valueOf() {
      return this.value;
    }
  }]);

  return Value;
}(Chain);

var Thunk = function (_Chain2) {
  _inherits(Thunk, _Chain2);

  function Thunk(fn) {
    var _this6;

    _classCallCheck(this, Thunk);

    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Thunk).call(this));
    _this6.fn = stable(fn);
    return _this6;
  }

  _createClass(Thunk, [{
    key: "valueOf",
    value: function valueOf() {
      return this.fn();
    }
  }]);

  return Thunk;
}(Chain);

function chain(value) {
  return new Value(value);
}

export { type, Semigroup, append, Monoid, reduce, Functor, map, Applicative, pure, apply, Monad, flatMap, Foldable, foldr, foldl, Filterable, filter, stable, chain };
//# sourceMappingURL=funcadelic.es.js.map
